import { Reveal, CtaButton } from "./primitives";

export const FinalCtaSection = () => (
  <section
    id="mappa"
    className="relative overflow-hidden py-32 sm:py-44"
    data-testid="final-cta-section"
  >
    <div
      className="absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/[0.08] blur-[130px]"
      aria-hidden
    />

    <div className="relative mx-auto max-w-4xl px-6 text-center sm:px-8">
      <Reveal>
        <h2 className="font-serif text-4xl sm:text-6xl lg:text-7xl font-medium leading-[1.02] tracking-tight text-white">
          Qual è la battaglia che stai{" "}
          <span className="italic text-gold">attraversando oggi?</span>
        </h2>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="mx-auto mt-8 max-w-xl space-y-4 text-base sm:text-lg font-light leading-relaxed text-white/75">
          <p>Non devi avere già tutte le risposte.</p>
          <p>
            A volte il primo passo è semplicemente trovare uno spazio dove poterti aprire
            davvero.
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="mt-14 font-serif text-3xl sm:text-5xl font-medium uppercase leading-tight tracking-tight text-gold">
          La tua storia merita
          <br />
          di essere ascoltata.
        </p>
      </Reveal>

      <Reveal delay={0.28}>
        <div className="mt-12">
          <CtaButton testId="final-cta" large className="w-full sm:w-auto">
            Richiedi la tua Mappa del Tempio
          </CtaButton>
          <p className="mt-5 text-sm font-light text-white/50">
            Privata • Gratuita • 30 minuti • Nessun obbligo
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
